const icons = {};

icons.xenome = <svg class="custom-icon custom-icon-github" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36">
<g id="Group_8654" data-name="Group 8654" transform="translate(3.999 -10.085)">
	<path id="Rectangle_4113" data-name="Rectangle 4113" d="M0,0H36a0,0,0,0,1,0,0V36a0,0,0,0,1,0,0H15A15,15,0,0,1,0,21V0A0,0,0,0,1,0,0Z" transform="translate(-3.999 10.085)" fill="#2b8dd8"></path>
	<path id="Path_66" data-name="Path 66" d="M14.7-2.663H10.863L.378-18.009H4.216ZM7.414-12.119l3.655-5.89h3.495L9.1-9.749Zm.64,2.853L3.9-2.663H.469l5.8-8.7Z" transform="translate(12.109 42.543)" fill="#fff"></path>
</g>
</svg>

export default icons;
